import { delay } from 'lodash'

export default function copyLink(delayAfterCopy = 2000) {
  return {
    copy() {
      const url = window.location.href

      copyToClipboard(url)

      this.setHasCopied()
      delay(this.setHasCopied.bind(this), delayAfterCopy, false)
    },
    setHasCopied(value = true) {
      this.hasCopied = value
    },
    hasCopied: false,
  }
}

function copyToClipboard(url) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url)
    return
  }
  const input = document.createElement('input')
  input.value = url
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
}
